import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'ChartPie';
const IconTitle = 'Chart pie';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.25 4.53703C7.46001 4.91332 4.5 8.11099 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5C13.8013 19.5 15.4533 18.8658 16.7466 17.8072L11.4697 12.5303C11.329 12.3897 11.25 12.1989 11.25 12V4.53703ZM12.75 4.53703V11.25H19.463C19.1112 7.70669 16.2933 4.88883 12.75 4.53703ZM19.463 12.75H13.8107L17.8072 16.7466C18.717 15.635 19.3134 14.2585 19.463 12.75ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 14.4851 19.9918 16.7361 18.364 18.364C16.7361 19.9918 14.4851 21 12 21C7.02944 21 3 16.9706 3 12Z" fill="currentColor"/>
  </svg>
`;

const ChartPieIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.25 4.53703C7.46001 4.91332 4.5 8.11099 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5C13.8013 19.5 15.4533 18.8658 16.7466 17.8072L11.4697 12.5303C11.329 12.3897 11.25 12.1989 11.25 12V4.53703ZM12.75 4.53703V11.25H19.463C19.1112 7.70669 16.2933 4.88883 12.75 4.53703ZM19.463 12.75H13.8107L17.8072 16.7466C18.717 15.635 19.3134 14.2585 19.463 12.75ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 14.4851 19.9918 16.7361 18.364 18.364C16.7361 19.9918 14.4851 21 12 21C7.02944 21 3 16.9706 3 12Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconTitle,

  IconComponent: ChartPieIcon,
  IconSvg: IconSvg
} as IconType;
